"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDefaults;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = require("react");

var e = function e(x, v) {
  return x === undefined ? v : x;
};

var m = function m(o1, o2) {
  return Object.keys(o2).reduce(function (res, k) {
    return (0, _extends3.default)({}, res, (0, _defineProperty2.default)({}, k, e(o1[k], o2[k])));
  }, o1);
};

var z = function z(o, s) {
  return (s || []).reduce(function (r, sx) {
    return m(r, sx);
  }, o || {});
};

function useDefaults(obj) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  return (0, _react.useMemo)(function () {
    return z(obj, sources);
  }, [obj, sources]);
}